// material-ui
import { LogoutOutlined } from '@ant-design/icons';
import { Box, Tooltip } from '@mui/material';
import IconButton from 'components/@extended/IconButton';
import { useIntl } from 'react-intl';
import { clearCookieStorage } from 'utils/commonFunctions';

// ==============================|| LOGOUT ||============================== //

const Logout = () => {

  const intl = useIntl();
  const handleLogout = async () => {
    try {
      clearCookieStorage();
      // await logout();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Box>
      <Tooltip title={intl.formatMessage({ id: `logout` })}>
        <IconButton size="medium" sx={{ color: 'text.primary' }} onClick={handleLogout}>
          <LogoutOutlined />
        </IconButton>
      </Tooltip>
    </Box>
  )
};

export default Logout;
